import React, { useState, useEffect } from 'react';
import SeasonWrapped from './SeasonWrapped';
import './SeasonWrappedModal.scss';

const SeasonWrappedModal = ({ isOpen, onClose }) => {
  const [showWrapped, setShowWrapped] = useState(false);

  // Don't show if not open
  if (!isOpen) return null;

  const handleViewWrapped = () => {
    setShowWrapped(true);
  };

  const handleCloseWrapped = () => {
    setShowWrapped(false);
    onClose();
  };

  const handleSkip = () => {
    onClose();
  };

  return (
    <>
      {!showWrapped && (
        <div className="season-wrapped-modal-overlay">
          <div className="season-wrapped-modal">
            <div className="modal-content">
              <div className="modal-icon">
                <span className="trophy-icon">🏆</span>
              </div>
              <h2 className="modal-title">Your 2025 Wrapped</h2>
              <p className="modal-description">
                Relive your best moments from 2025! See your matches, goals, achievements and more.
              </p>
              <div className="modal-actions">
                <button className="btn-primary" onClick={handleViewWrapped}>
                  View My Wrapped
                </button>
                <button className="btn-secondary" onClick={handleSkip}>
                  Maybe Later
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      <SeasonWrapped isOpen={showWrapped} onClose={handleCloseWrapped} />
    </>
  );
};

export default SeasonWrappedModal;

